
function Footer() {

    function renderFooter(){
        if(process.env.REACT_APP_CLIENT === "ALSET"){

            return <div className="bg-[rgb(34,34,34)] bottom-0 h-full p-5 mt-5 ">
                <div className="m-auto w-[90vw] md:w-[60vw] xl:w-[60vw] 2xl:w-[60vw] text-[#c9cac8]">
                Alset Insurance Services, LLC is the Managing General Agency for In The Car, LLC. Products are underwritten by Redpoint 
                County Mutual and Incline Property & Casualty Company. Home Office: Austin, TX. Agency of Record: Alset Insurance Services, LLC. 
                Subsidiary of In The Car, LLC. Home Office: Stamford, CT. Insurance terms, definitions and explanations are intended for 
                informational purposes only and do not in any way replace or modify the definitions and information contained in individual 
                insurance contracts, policies or declaration pages, which are controlling. Subject to underwriting guidelines, review and approval. 
                Products and discounts are not offered by all companies. Not all products and discounts are available to all persons in all states.
                </div>
            </div>
        }

        if(process.env.REACT_APP_CLIENT === "LINCOLN"){

            return <div className="bg-[rgb(34,34,34)] bottom-0 h-full p-5 mt-5 ">
                <div className="m-auto w-[90vw] md:w-[60vw] xl:w-[60vw] 2xl:w-[60vw] text-[#c9cac8]">
                Alset Insurance Services, LLC is the Managing General Agency for In The Car, LLC. Lincoln Motor Company Insure is a 
                product presented by Ford Motor Insurance Agency (FMIA NPN 95889, CA license #0C02678), a Ford affiliate and licensed 
                insurance agency. Lincoln Motor Company Insure is underwritten by Redpoint County Mutual and Incline Property & Casualty 
                Company. Home Office: Austin, TX. Agency of Record: Alset Insurance Services, LLC. Subsidiary of In The Car, LLC. 
                Home Office: Stamford, CT. Insurance terms, definitions and explanations are intended for informational purposes
                only and do not in any way replace or modify the definitions and information contained in individual insurance contracts, 
                policies or declaration pages, which are controlling. Subject to underwriting guidelines, review and approval. Products 
                and discounts are not offered by all companies. Not all products and discounts are available to all persons in all states.
                </div>
            </div>
        }

        return <div className="bg-[rgb(34,34,34)] bottom-0 h-full p-5 mt-5 ">
                <div className="m-auto w-[90vw] md:w-[60vw] xl:w-[60vw] 2xl:w-[60vw] text-[#c9cac8]">
                Alset Insurance Services, LLC is the Managing General Agency for In The Car, LLC. Ford Insure is a product presented by Ford Motor 
                Insurance Agency (FMIA NPN 95889, CA license #0C02678), a Ford affiliate and licensed insurance agency. Ford Insure is underwritten 
                by Redpoint County Mutual and Incline Property & Casualty Company. Home Office: Austin, TX. Agency of Record: Alset Insurance 
                Services, LLC. Subsidiary of In The Car, LLC. Home Office: Stamford, CT. Insurance terms, definitions and explanations are 
                intended for informational purposes only and do not in any way replace or modify the definitions and information contained in 
                individual insurance contracts, policies or declaration pages, which are controlling. Subject to underwriting guidelines, review 
                and approval. Products and discounts are not offered by all companies. Not all products and discounts are available to all persons 
                in all states.
                </div>
            </div>;
    }


    return  (
        renderFooter()
    );
}

export default Footer;